import React, { useEffect, useState } from "react";
import { object, bool, number, string, array } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import StoryMetaData from "../StoryMetaData";
import { getExcerpt, getHeadline } from "../../utils/utils";

import "./customStoryCard4.m.css";

const CustomStoryCard4 = ({
  story,
  headerLevel = 2,
  headlineType = 13,
  showStoryMetaInfo = false,
  className = "",
  showMetaDataForDesktop = false,
  isSubheadline = true,
  widths = [150],
  excerptLevel = 4,
  subHeadlineType = 6,
  isExcerpt = false,
  darkTheme = false,
  largeIcon = false,
  publisherAttributes,
  updatedFont = false,
  src = "",
  changeAspectRatio,
  updateSubHeadline = false,
  isCommentedStory = false,
  langClass = "",
  changeImageType = "",
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => {
  const { subheadline } = story;
  const storyHeadlineStyle = updatedFont ? `${publisherAttributes.lang}-story-headline` : "";
  const customStoryHeadlineStyle = updatedFont && src ? `${publisherAttributes.lang}-story-headline-${src}` : "";
  const headlineStyle = src ? customStoryHeadlineStyle : storyHeadlineStyle;
  const storySubHeadlineStyle = updatedFont ? `${publisherAttributes.lang}-sub-headline` : "";
  const customStorySubHeadlineStyle = updateSubHeadline && src ? `${publisherAttributes.lang}-sub-headline-${src}` : "";
  const subHeadlineStyle = updateSubHeadline && src ? customStorySubHeadlineStyle : storySubHeadlineStyle;

  const excerptStyle = updatedFont ? `${publisherAttributes.lang}-excerpt` : "";
  const [isTab, setIsTab] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const aspectRatio = isTab ? [16, 9] : [4, 3];
  const imageType = changeImageType || (isTab ? "image16x9" : "image4x3");
  const storyHeadline = getHeadline(story);
  const excerpt = getExcerpt(story);

  useEffect(() => {
    if (global.deviceWidth > 875 && global.deviceWidth < 1264) {
      setIsTab(true);
    }
    global.deviceWidth > 875 && setIsDesktop(!isDesktop);
  }, []);

  return (
    <div
      styleName={`base`}
      className={`custom-story-card-4 ${publisherAttributes.lang}-custom-story-card-4-base ${className} ${langClass}`}
    >
      <Link
        href={story.url}
        className="hero-image"
        data-tracking-category={datatrackingcategory}
        data-tracking-action={datatrackingaction}
        data-tracking-label={datatrackinglabel}
      >
        <CardImage
          story={story}
          aspectRatio={changeAspectRatio || (global.deviceWidth < 876 ? [3, 2] : aspectRatio)}
          imageType={global.deviceWidth < 876 ? "image3x2" : imageType}
          widths={widths}
          showAlternateImage={true}
          darkTheme={darkTheme}
          largeIcon={largeIcon}
          isCommentedStory={isCommentedStory}
        />
      </Link>
      <div className="custom-story-card-4-data">
        {isSubheadline && subheadline ? (
          <Link href={story.url}>
            <Headline text={subheadline} headerLevel={3} className="section-name" styleName={subHeadlineStyle} />
          </Link>
        ) : null}
        <Link
          href={story.url}
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label={datatrackinglabel}
        >
          <Headline
            text={storyHeadline}
            headerLevel={headerLevel}
            headlineType={headlineType}
            className="story-headline"
            styleName={headlineStyle}
          />
        </Link>
        {isDesktop && isExcerpt && excerpt ? (
          <Link
            href={story.url}
            data-tracking-category={datatrackingcategory}
            data-tracking-action={datatrackingaction}
            data-tracking-label={datatrackinglabel}
          >
            <Headline
              text={excerpt}
              headerLevel={excerptLevel}
              headlineType={subHeadlineType}
              className={`sub-headline ${excerptStyle}`}
              styleName={excerptStyle}
              dangerouslySet={true}
            />
          </Link>
        ) : null}
        {(isTab || showMetaDataForDesktop) && showStoryMetaInfo && (
          <StoryMetaData story={story} updatedFont={updatedFont} publisherLang={publisherAttributes.lang} src={src} />
        )}
      </div>
    </div>
  );
};

CustomStoryCard4.propTypes = {
  story: object.isRequired,
  headerLevel: number,
  headlineType: number,
  isTag: bool,
  showStoryMetaInfo: bool,
  className: string,
  showMetaDataForDesktop: bool,
  widths: array,
  isSubheadline: bool,
  excerptLevel: number,
  subHeadlineType: number,
  isExcerpt: bool,
  darkTheme: bool,
  largeIcon: bool,
  updatedFont: bool,
  publisherAttributes: object,
  src: string,
  changeAspectRatio: array,
  updateSubHeadline: bool,
  isCommentedStory: bool,
  langClass: string,
  changeImageType: string,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(CustomStoryCard4);
